// import axios from "axios";
import businessGroupActionTypes from "../types/businessGroupActionTypes";
import businessGroupService from "./../../services/businessGroup.service";
import actionType from '../../enums/actionEnum'

export const getBusinessGroups = () => async (dispatch) => {
    try {
        var response = await businessGroupService.getBusinessGroupsByOpu();
        dispatch({
            type: businessGroupActionTypes.GET_BUSINESS_GROUPS_SUCCESS,
            payload: response.data,

        });
    } catch (error) {
        dispatch({
            type: businessGroupActionTypes.GET_BUSINESS_GROUPS_FAILURE,
            payload: error,
        });
    }

};

export const updateBusinessGroup = (businessGroup) => async (dispatch) => {

    try {
        dispatch({
            type: businessGroupActionTypes.START_UPDATE_BUSINESS_GROUP,
        });
        var response = await businessGroupService.updateBusinessGroup(businessGroup);
        dispatch({
            type: businessGroupActionTypes.UPDATE_BUSINESS_GROUP_SUCCESS,
            payload: response.data,
            action: actionType.update
        });
    } catch (error) {
        dispatch({
            type: businessGroupActionTypes.UPDATE_BUSINESS_GROUP_FAILURE,
            payload: error.response,
            action: actionType.update
        });

    }
};

export const addBusinessGroup = (businessGroup) => async (dispatch) => {

    try {
        dispatch({
            type: businessGroupActionTypes.START_ADD_BUSINESS_GROUP,
        });
        var response = await businessGroupService.addBusinessGroup(businessGroup);
        dispatch({
            type: businessGroupActionTypes.ADD_BUSINESS_GROUP_SUCCESS,
            payload: response.data,
            action: actionType.add
        });
    } catch (error) {
        dispatch({
            type: businessGroupActionTypes.ADD_BUSINESS_GROUP_FAILURE,
            payload: error.response,
            action: actionType.add
        });

    }
};

export const deleteBusinessGroup = (id) => async (dispatch) => {
    try {
        dispatch({
            type: businessGroupActionTypes.START_DELETE_BUSINESS_GROUP,
        });
        var response = await businessGroupService.deleteBusinessGroup(id);
        dispatch({
            type: businessGroupActionTypes.DELETE_BUSINESS_GROUP_SUCCESS,
            payload: response.data,
            action: actionType.delete
        });
    } catch (error) {
        dispatch({
            type: businessGroupActionTypes.DELETE_BUSINESS_GROUP_FAILURE,
            payload: error.response,
            action: actionType.delete

        });

    }
};


export const setSelectedBusinessGroup = selectedBusinessGroup => (dispatch) => {
    dispatch({ type: businessGroupActionTypes.SELECT_BUSINESS_GROUP, payload: selectedBusinessGroup });
};

export const UnSelecteBusinessGroup =()=> (dispatch) => {
    localStorage.removeItem('selectedBusinessGroup');
    dispatch({ type: businessGroupActionTypes.UNSELECT_BUSINESS_GROUP });
};

export const resetStateInfo = () => (dispatch) => {
    dispatch({ type: businessGroupActionTypes.RESET_STATE_INFO })
};



const businessGroupActions = {
    getBusinessGroups,
    addBusinessGroup,
    updateBusinessGroup,
    deleteBusinessGroup,
    setSelectedBusinessGroup,
    UnSelecteBusinessGroup,
    resetStateInfo
};
export default businessGroupActions;







